import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { getEnrollments } from "../../../api/endpoints/EnrollmentEndpoints";
import { Enrollment } from "../../../models/Enrollment";
import { Paged } from "../../../models/Paged";

export default function useGetEnrollmentsPaginated() {
  return useMutation<Paged<Enrollment>, AxiosError, { page: number }>({
    mutationKey: ["enrollments"],
    mutationFn: ({ page }) => getEnrollments(page),
  });
}
